<div class="row content__grid">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 m-t-15">
        <div class="row">
            <div class="col-lg-4">
                <div class="card m-b-30">
                    <h5 class="card-header mt-0 f-s-15 bold">Reservas</h5>
                    <div class="card-body p-l-10 p-r-10">
                        <ul class="p-l-25">
                            <li class="f-s-14 m-b-5">
                                <a routerLink="/{{branchofficeSlug}}/reportes/reservas/resumen_asesor">Resumen por asesor</a>
                            </li>
                            <!-- <li class="f-s-14 m-b-5">
                                <a routerLink="/{{branchofficeSlug}}/reportes/cuadreshotel/lista">Resumen origen de reserva</a>
                            </li> -->
                            <!-- <li class="f-s-14 m-b-5">
                                <a routerLink="/{{branchofficeSlug}}/reportes/cuadresagencia/lista">Cuadres de agencias</a>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="card m-b-30">
                    <h5 class="card-header mt-0 f-s-15 bold">Cuadres de empresa</h5>
                    <div class="card-body p-l-10 p-r-10">
                        <ul class="p-l-25">
                            <li class="f-s-14 m-b-5">
                                <a routerLink="/{{branchofficeSlug}}/reportes/cuadreshotel/lista">Cuadres de hotel</a>
                            </li>
                            <li class="f-s-14 m-b-5">
                                <a routerLink="/{{branchofficeSlug}}/reportes/cuadresagencia/lista">Cuadres de agencias</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="card m-b-30">
                    <h5 class="card-header mt-0 f-s-15 bold">Salidas</h5>
                    <div class="card-body p-l-10 p-r-10">
                        <ul class="p-l-25">
                            <li class="f-s-14 m-b-5">
                                <a routerLink="/{{branchofficeSlug}}/reportes/salidas/cronograma">Resumen Cronograma</a>
                            </li>
                            <li class="f-s-14 m-b-5">
                                <a routerLink="/{{branchofficeSlug}}/reportes/salidas/grupos">Reporte Grupos</a>
                            </li>
                            <li class="f-s-14 m-b-5">
                                <a routerLink="/{{branchofficeSlug}}/reportes/salidas/guias">Reporte por guías de viaje</a>
                            </li>
                            <li class="f-s-14 m-b-5">
                                <a routerLink="/{{branchofficeSlug}}/reportes/salidas/transporte">Reporte por Transporte</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="card m-b-30">
                    <h5 class="card-header mt-0 f-s-15 bold">Reporte ventas</h5>
                    <div class="card-body p-l-10 p-r-10">
                        <ul class="p-l-25">
                            <li class="f-s-14 m-b-5">
                                <a routerLink="/{{branchofficeSlug}}/reportes/facturacion/documentos">Comprobantes electrónicos</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-4">
                <div class="card m-b-30">
                    <h5 class="card-header mt-0 f-s-15 bold">Restaurante</h5>
                    <div class="card-body p-l-10 p-r-10">
                        <ul class="p-l-25">
                            <li class="f-s-14 m-b-5">
                                <a href="#">Lista Pisos / ambientes</a>
                            </li>
                            <li class="f-s-14 m-b-5">
                                <a href="#">Lista de mesas</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>